// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Default_sliderWrapper__giYY9","heycarSlider":"Default_heycarSlider__qELy8","isWithHistogram":"Default_isWithHistogram__rXIdg","disabled":"Default_disabled__BWXcU"};